













import { Mobile } from "@/mixins/mobile";
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
@Component
export default class Search extends Mixins(Mobile) {
  @Prop({ default: "Enter search term..." }) placeholderText!: string;
  private search = "";

  public clearSearch() {
    this.search = "";
    this.sendSearch();
  }

  @Watch("search")
  public sendSearch(): void {
    this.$emit("submitSearch", this.search);
  }
}
